import { ReaderChapter } from '@/services/booksApi';
import { resolveReaderLink } from '@/utils/readerFragments';

// Removes the note's return-to-citation backlink. Identified structurally --
// the last anchor in the note whose href resolves back to the citing
// chapter -- rather than by matching the backlink glyph (e.g. "↩︎"), since
// that's convention-independent and survives markup/localization variants.
export const stripBacklink = (
  note: HTMLElement,
  endnotesChapter: ReaderChapter,
  citingChapterId: string,
  chapters: ReaderChapter[],
): HTMLElement => {
  const clone = note.cloneNode(true) as HTMLElement;
  const anchors = Array.from(clone.querySelectorAll('a'));
  for (let i = anchors.length - 1; i >= 0; i -= 1) {
    const anchor = anchors[i];
    const target = resolveReaderLink(anchor, endnotesChapter, chapters);
    if (target?.chapterId === citingChapterId) {
      anchor.remove();
      break;
    }
  }
  return clone;
};
